import {isNil} from 'ramda';

import {readOAuthFlowCookie} from './readOAuthFlowCookie';

export const selectOAuthFlow = (
  candidates: ReturnType<typeof readOAuthFlowCookie>,
  state: string | null
) => (isNil(state) ? undefined : candidates.find((candidate) => candidate.state === state));
